"attribute".datatype({source: "WC", readOnly: true})
"name".field({key: true})
